export default class BlockAccordion {
    constructor(container, options) {
        const defaultOptions = {
            tabs: '.block-container .item'
        };

        this.options = Object.assign({}, defaultOptions, options);
        this.container = document.querySelector(container);
        this.tabs = this.container.querySelectorAll(this.options.tabs);
        
        this.setEvents();
        this.onLoad();   
    }

    setEvents() {
        var self = this;
        this.tabs.forEach(tab => {
           tab.addEventListener('click', function() { self.clickTab(this); }); 
        });
    }

    onLoad() {  
        var params = (new URL(document.location)).searchParams
        var id = params.get("show")

        if (id !== null) {
          this.filterMiniFaq(id);
        }
  
        for (let i = 0; i < this.itemsOpen && i < this.tabs.length; i++) {
          this.tabs[i].classList.add('show-block');
        }
  
        this.tabs.forEach(block => {
          block.addEventListener('click', () => {
            this.toggleBlockAccordion(block)
          })
        })
    }

    toggleBlockAccordion(clickedBlock) {
        this.tabs.forEach(block => {
          if (block === clickedBlock) {
            block.classList.toggle('show-block')
          } else {
            block.classList.remove('show-block')
          }
        })
      }

    filterMiniFaq(id) {
        this.tabs.forEach(tab => {
            if (tab.classList.contains('show')) {
                tab.classList.remove('show')
            } else {
                tab.classList.add('show')
            }
  
            if (tab.classList.contains(id)) {
                tab.classList.add('active')
            } else {
                tab.classList.remove('active')
            }
        })
    }
}